document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    var targetLink = e.target.closest('a');
    if (!targetLink || !targetLink.getAttribute('href')) return;
    var href = targetLink.getAttribute('href');
    if (href.startsWith('#') && href.length > 1) {
      var targetId = href.substring(1);
      var targetSection =
        document.getElementById(targetId) || document.querySelector('[data-id="' + targetId + '"]');
      if (targetSection) {
        e.preventDefault();
        var targetPosition = targetSection.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: targetPosition - 50, behavior: 'smooth' });
      }
    }
  });
});
